import "./Switch.scss"

import { Box } from "@mui/material"
import React from "react"
import GradientWrapper from "./GradientWrapper"
import Text from "./Text"

interface SwitchProps<T> {
  tabs: {
    label: string
    value: T
  }[]
  activeValue: T
  onChange: (value: T) => void
}

function Switch<T>({ tabs, activeValue, onChange }: SwitchProps<T>) {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      className="comopnents-switch"
      borderRadius="20px"
      padding="6px 2px"
      bgcolor="#000000"
    >
      {tabs.map((tab) => (
        <Box
          key={tab.label}
          className={tab.value !== activeValue ? "inactive" : ""}
          onClick={() => onChange(tab.value)}
          sx={{ cursor: "pointer" }}
          mx="6px"
        >
          <GradientWrapper borderRadius="20px" background="#000000">
            <Text
              variant="button"
              fontSize="12px"
              textTransform="uppercase"
              padding="4px 24px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              {tab.label}
            </Text>
          </GradientWrapper>
        </Box>
      ))}
    </Box>
  )
}

export default Switch
